// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-height: 1400px) {\n.rightBar[data-v-d6753d96] .side {\n    width: 24% !important;\n}\n}\n", ""]);
// Exports
module.exports = exports;
